import React from 'react'

import styled from 'styled-components'
import Fade from 'react-reveal/Fade';


import hamburger from "../static/hamburger.svg"
import factory from "../static/factory.svg"
import ideas from "../static/ideas.svg"
import plans from "../static/plans.svg"
import thoughts from "../static/thoughts.svg"

const StyledIntro = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 60px;

  .item {
    min-height: 30vh;
    max-width: 800px;
    padding-top: 10vh;
    
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    

    @media screen and (max-width: 900px) {
      { flex-wrap: wrap;  }
      h1 {
        padding-top: 1em;
        text-align: center;
      }
    }

    h1 {
      padding: 10px;
      font-size: calc(1em + 1vw);
    }
   
    img {
      width: 100%;
      max-width: 500px;
    }
  }
`

const duration = 2000

export default () => (
  <StyledIntro>
    <Fade bottom duration={duration}>
      <div className="item">
        <img src={hamburger} alt="Logo" />
        <h1>Hvordan skal vi mate fremtidens befolkning?</h1>
      </div>
    </Fade>


    <Fade bottom>
      <div className="item" duration={duration}>
        <img src={thoughts} alt="Logo" />
        <h1>Vi trenger nye ideer...</h1>
      </div>
    </Fade>

    <Fade bottom>
      <div className="item" duration={duration}>
        <img src={factory} alt="Logo" />
        <h1>Biprodukter kan bli fremtidens mat</h1>
      </div>
    </Fade>

    <Fade bottom>
      <div className="item" duration={duration}>
        <img src={plans} alt="Logo" />
        <h1>Men det krever at vi endrer hvordan vi ser på biprodukter</h1>
      </div>
    </Fade>

    <Fade bottom>
      <div className="item" duration={duration}>
        <img src={ideas} alt="Logo" />
        <h1>Holdningsendringer kan mate verden</h1>
      </div>
    </Fade>

  </StyledIntro >
)